
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"24","height":"24","rx":"12","fill":"#EDF2F7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 7.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H8a.5.5 0 010-1h3.5V8a.5.5 0 01.5-.5z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.5 12a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V16a.5.5 0 01-1 0v-4z","fill":"#000"}})])
          )
        }
      }
    